import { useGetOrderQuery } from '../apis/mlkApi/mlk.api.hooks';
import { useIsNoAssign } from './useIsNoAssign';
import { useOrderId } from './useOrderId';

export const useOrder = () => {
  const orderId = useOrderId();
  const isNoAssign = useIsNoAssign();

  const { data: order } = useGetOrderQuery(
    { orderId: orderId || '', isNoAssign },
    {
      skip: !orderId,
    }
  );

  return order;
};
